export enum Route{
  product='/vcProduct',
  user='/vcUser',
}
